import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSIntegrationsCollection = GenericCollectionFactory("PMS_INTEGRATIONS", "uid")